/// <amd-module name="Build/Admin/Pool/Stores/TopPipelinesStore" />
import { extractODataError } from "Analytics/Common/Utilities/AnalyticsExceptionUtilities";
import { IPipelinesConsumptionData } from "Build/Admin/Pool/Types";
import { Store } from "VSS/Reflux/Store";

export interface ITopPipelinesCardState {
    data?: IPipelinesConsumptionData[];
    errorText?: string;
}

export class TopPipelinesStore extends Store {
    protected _state: ITopPipelinesCardState = {};
    constructor() {
        super("TopPipelinesStoreChanged");
    }

    public getConsumptionState(): ITopPipelinesCardState {
        return this._state;
    }

    public _onError = (error: Error) => {
        const errorText = extractODataError(error);
        this._state.errorText = errorText;
        this.emitChanged();
    };

    public _onUpdateData = (consumptionData: IPipelinesConsumptionData[]) => {
        if (consumptionData) {
            this._state.errorText = undefined;
            this._state.data = consumptionData;
            this.emitChanged();
        }
    };
}
